import React, { useCallback, useState } from "react"
import {
  ActivitySummary,
  OverviewCards,
  Tabs,
  TopLocations,
  RevenueAndEarnings,
  TopVendors,
  CategoryDistribution,
  ActiveCustomers,
} from "pages/admin/Dashbaord/components"
import { Orders } from "pages/admin/Orders"
import { Products } from "pages/admin/Products"
import { Coupons } from "pages/admin/Coupons"
import { DeliveryMen } from "pages/admin/Delivery-men"
import { Disputes } from "pages/admin/Disputes"
import { Card, Col, Row } from "reactstrap"
import { useTranslation } from "react-i18next"

export enum CurrentTapType {
  orders = "Orders",
  products = "Products",
  coupons = "Coupons",
  Deliveries = "Deliveries",
  disputes = "Disputes",
}

enum Time {
  ALL = "dashboard_all",
  ONE_MONTH = "dashboard_oneMonth",
  SIX_MONTH = "dashboard_sixMonths",
  ONE_YEAR = "dashboard_oneYear",
}
const times: Time[] = [Time.ALL, Time.ONE_MONTH, Time.SIX_MONTH, Time.ONE_YEAR]

export const Dashboard = () => {
  const { t, i18n } = useTranslation()
    const [currentTap, setCurrentTap] = useState<CurrentTapType>(CurrentTapType.orders)
    const [currentTime, setCurrentTime] = useState(Time.ALL)

    const onchangeTabHandler = useCallback((  tab: CurrentTapType) => {
      setCurrentTap(tab)
    }, [setCurrentTap])

    const onDateRangeChange = (startDate: string, endDate: string) => {
      console.log("Selected date range:", startDate, "to", endDate)
    }

    const handleTimeChange = useCallback((time: Time) => {
      setCurrentTime(time)
    }, [])

  return (
    <div className="page-content">
      <div className="container-fluid d-flex flex-column gap-4">
        <div className="mb-1">
          <h4 className="mb-sm-0 font-size-24 text-capitalize fw-semibold pb-2">
            {t("dashboard_welcome", { name: "Hamza" })}
          </h4>
          <span
            className="font-size-12 fw-semibold"
            style={{ color: "#647683" }}
          >
            {t("dashboard_trackOrder")}
          </span>
        </div>
        <div className="d-flex align-items-center gap-1 justify-content-start">
          {times.map((time, index) => (
            <button
              key={index}
              className={`font-size-12 fw-regular ${
                time === currentTime
                  ? "text-primary bg-primary-30"
                  : "bg-cyan-30 text-cyan"
              }`}
              style={{
                border: "none",
              }}
              onClick={() => handleTimeChange(time)}
            >
              {i18n.t(time)}
            </button>
          ))}
        </div>
        <OverviewCards />
        <Row style={{ rowGap: "1.5rem" }}>
          <Col xl="9">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <RevenueAndEarnings />
            </Card>
          </Col>
          <Col xl="3">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <TopVendors />
            </Card>
          </Col>
        </Row>
        <Row style={{ rowGap: "1.5rem" }}>
          <Col md="5">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <ActivitySummary />
            </Card>
          </Col>
          <Col md="7">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <TopLocations />
            </Card>
          </Col>
        </Row>
        <Card
          style={{ margin: 0 }}
          className="mini-stats-wid shadow-md rounded-3 p-3"
        >
          <Tabs onChangeHandler={onchangeTabHandler} />
          {currentTap === CurrentTapType.orders && <Orders isDashboardPage />}
          {currentTap === CurrentTapType.products && (
            <Products isDashboardPage />
          )}
          {currentTap === CurrentTapType.coupons && <Coupons isDashboardPage />}
          {currentTap === CurrentTapType.Deliveries && (
            <DeliveryMen isDashboardPage />
          )}
          {currentTap === CurrentTapType.disputes && (
            <Disputes isDashboardPage />
          )}
        </Card>
        <Row style={{ rowGap: "1.5rem" }}>
          <Col xl="3">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <CategoryDistribution />
            </Card>
          </Col>
          <Col xl="9">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <ActiveCustomers />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
